module.exports = __webpack_public_path__ + "media/images/admin/icons/chevron-up-0f9ac6feebc71692b1c5edb4cb434f54.svg";